import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MoveContainerRequest } from 'app/generated/backend/shipment/api/move-container-request';
import { MoveContainerResponse } from 'app/generated/backend/shipment/api/move-container-response';
import { ShipmentDetailModel } from 'app/generated/backend/shipment/api/shipment-detail-model';

@Injectable()
export class MoveContainerHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		shipmentNumber: string,
		partyId: number
	): Observable<JsonResourceResponse<MoveContainerResponse[]>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (shipmentNumber!==null && shipmentNumber!==undefined) {
			params = params.set('shipmentNumber', shipmentNumber);
		}
		if (partyId!==null && partyId!==undefined) {
			params = params.set('partyId', partyId.toString());
		}
		return this.http.get<JsonResourceResponse<MoveContainerResponse[]>>('api/v1/shipment/moveContainer', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	post(
		request: MoveContainerRequest
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		return this.http.post<JsonResourceResponse<ShipmentDetailModel>>('api/v1/shipment/moveContainer', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		MoveContainerHandlerService
	]
})
export class MoveContainerHandlerModule { }
